class ImageContent {
  constructor() {
    this.mapInit();
  }

  mapInit = async () => {
    const mapContainer = document.getElementById("map");
    if (!mapContainer) {
      return;
    }
    let map;
    const position = { lat: 45.239292536723376, lng: 19.76381204012667 };

    // Create a map

    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    map = new Map(mapContainer, {
      zoom: 12,
      center: position,
      mapId: "DEMO_MAP_ID",
    });

    // Add a marker
    const marker = new AdvancedMarkerElement({
      map: map,
      position: position,
      title: "Martinov Design",
    });
  };
}

new ImageContent();
